export default __webpack_public_path__ + "static/media/exit.ae12f829.svg";